import { UsergroupAddOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import LeadCreateMenu from 'automations/components/Nodes/LeadCreateMenu';
import { type LeadCreateNodeType } from 'automations/types/nodeTypes';
import { didNodeSyncToServer } from 'automations/utils/node';
import { useMemo } from 'react';

import { type TriggerNodeReturnProps } from './useTriggerNodeConfig';

export default function useLeadCreate(node: NodeProps<LeadCreateNodeType>): TriggerNodeReturnProps {
  const isSyncedToServer = didNodeSyncToServer(node);

  const errorMessages: string[] = [
    !isSyncedToServer && 'Save the node before adding new nodes',
  ].filter(Boolean) as string[];
  const hasErrors = errorMessages.length > 0;

  const AdditionalUI = useMemo(() => <LeadCreateMenu node={node} />, [node]);

  return {
    icon: UsergroupAddOutlined,
    hasErrors,
    errorMessages,
    AdditionalUI,
  };
}
